import type { FC } from 'react';
import styled from 'styled-components';
import { Text } from '@visx/text';
import type { TextProps } from '@/thirdparty/@vx/text';
interface Props extends TextProps {
  value: number;
}

const TitleTextComponent: FC<Props> = ({ children, ...rest }) => (
  <Text {...(rest as any)}>{children}</Text>
);

export const Shares = styled(TitleTextComponent)<Props>`
  tspan {
    ${({ theme }) => theme.typography.tiny}
    fill: ${({ theme, value }) => theme.color.whiteRGBA(value > 0 ? 1 : 0.3)};
  }
`;

export const Value = styled('text')`
  ${({ theme }) => theme.typography.tiny}
  fill: ${({ theme }) => theme.color.whiteRGBA(0.5)};
`;

export const LabelWrapper = styled('svg')`
  overflow: visible;
`;
